<div class="page-container">
  @if (pageLoading()) {
  <app-loading-modal [content]="'loading styles'"></app-loading-modal>
  }
  <app-page-content-wrapper [goBack]="goBack.bind(this)">
    <div class="page-title web-tab-only">
      <h1>
        @if (!state().uploadDesign) { Select a Style } @if (state().uploadDesign) { Upload Design: Select a Style }
      </h1>
    </div>
    <div class="page-content">
      <!-- web-tab-only -->
      @if (!failedcategories()) {
      <div class="row web-tab-only">
        @for (subcategory of subcategories(); track trackByFn($index, subcategory)) {
        <app-product-card
          [ngStyle]="subcategories().length < 3 ? { width: '50%' } : { width: '33%' }"
          [categoryCode]="state().categoryCode"
          [subcategory]="subcategory"
          [uploadDesign]="state().uploadDesign"
        ></app-product-card>
        }
      </div>
      }
      <!-- mobile-only -->
      <div class="mobile-tab-only">
        <div class="cta-block white-background fedex">
          <div class="size-alert">
            <p>
              3D Builder is not available on mobile. Please switch to desktop or tablet view to customize this design.
            </p>
          </div>
        </div>
      </div>
    </div>
  </app-page-content-wrapper>

  <form name="back" #back ngNoForm [action]="state().referer" method="post">
    <input name="action" type="hidden" value="cancel" />
  </form>

  <ng-template #notFoundModal>
    <app-not-found-modal></app-not-found-modal>
  </ng-template>
</div>
